/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Picker_Hint_Multiple_VideoInputs */

const vi_media_picker_hint_multiple_video = /** @type {(inputs: Media_Picker_Hint_Multiple_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm để chọn nhiều video rồi bấm Chọn; video vừa tải lên được chọn sẵn.`)
};

/**

* @param {Media_Picker_Hint_Multiple_VideoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_picker_hint_multiple_video = /** @type {((inputs?: Media_Picker_Hint_Multiple_VideoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Picker_Hint_Multiple_VideoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_picker_hint_multiple_video(inputs)
});